import apac from "./products.APAC.json";
import clinics from "./products.clinics.json";
import bawc from "./products.BAWC.json";
import uk from "./products.UK.json";
import camp from "./products.Camp.json";


export const PRODUCT_SECTIONS = [
  {
    key: "BAWC",
    title: "BAWC Packages",
    products: bawc
  },
  {
    key: "clinics",
    title: "Clinics Packages",
    products: clinics
  },
  {
    key: "UK",
    title: "UK Packages",
    products: uk
  },
  {
    key: "APAC",
    title: "APAC Packages",
    products: apac
  },
  {
    key: "Camp",
    title: "Camp Packages",
    products: camp
  }
];
